import http from '@/utils/http';
import { IDENTITY_KEY_NAME } from '@/constants';
import { getIdentity } from '@/utils/detectDevice';

const list = () => http.apiGet(`/categories?uid=${getIdentity(IDENTITY_KEY_NAME.UID)}`);

export default {
  list,
};
